import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { MapPreview, ChartPreview, previewFor } from './Previews';
const lines = text => String(text || '').split('\n').map(l => l.trim()).filter(Boolean);

/** "Insights: public data and ..." -> { title: 'Insights', text: 'Public data and ...' } */
const point = l => {
  const i = l.indexOf(':');
  if (i < 1 || i > 40) return {
    title: '',
    text: l
  };
  const text = l.slice(i + 1).trim();
  return {
    title: l.slice(0, i).trim(),
    text: text.charAt(0).toUpperCase() + text.slice(1)
  };
};

/** /business - Voucha for Business. All wording from Admin > Voucha Ads. */
export default class BusinessPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    app.setTitle('Voucha for Business');
    app.setTitleCount(0);
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/voucha-ads/page'
    }).then(d => this.data = d).catch(() => this.data = {
      copy: {},
      contactEmail: 'advertise@thevoucha.com'
    }).finally(() => m.redraw());
  }
  view() {
    if (!this.data) return m("div", {
      className: "VouchaAdvertise container"
    }, m(LoadingIndicator, null));
    const {
      copy,
      contactEmail
    } = this.data;
    return m("div", {
      className: "VouchaAdvertise VouchaBusiness container"
    }, m("header", {
      className: "VouchaAdvertise-hero VouchaAdvertise-hero--split"
    }, m("div", {
      className: "VouchaAdvertise-heroText"
    }, m("div", {
      className: "VouchaAdvertise-kicker"
    }, "Voucha for Business"), m("h1", null, copy.businessTitle || 'Voucha for Business'), m("p", {
      className: "VouchaAdvertise-subtitle"
    }, copy.businessSubtitle), m("div", {
      className: "VouchaAdvertise-heroActions"
    }, m("a", {
      className: "Button Button--primary",
      href: 'mailto:' + contactEmail + '?subject=' + encodeURIComponent('Voucha for Business')
    }, "Get in touch"), m("a", {
      className: "Button",
      href: app.route('voucha-ads.advertise'),
      onclick: e => {
        e.preventDefault();
        m.route.set(app.route('voucha-ads.advertise'));
      }
    }, "Advertise on Voucha"))), m("div", {
      className: "VouchaAdvertise-heroArt"
    }, m(MapPreview, null), m("div", {
      className: "VouchaAdvertise-heroFloat"
    }, m(ChartPreview, {
      kicker: "Community data",
      title: "Salaries by city"
    })))), lines(copy.businessPoints).length ? m("section", {
      className: "VouchaAdvertise-section"
    }, m("div", {
      className: "VouchaAdvertise-formats"
    }, lines(copy.businessPoints).map(point).map(pt => m("div", {
      className: "VouchaAdvertise-format has-preview"
    }, m("div", {
      className: "VouchaAdvertise-formatArt"
    }, m(previewFor(pt.title || pt.text))), pt.title ? m("h3", null, pt.title) : null, m("p", null, pt.text))))) : null, m("p", {
      className: "VouchaAdvertise-muted VouchaBusiness-contact"
    }, "Write to ", m("a", {
      href: 'mailto:' + contactEmail
    }, contactEmail), ", and we will respond within one working day."));
  }
}
flarum.reg.add('voucha-ads', 'forum/components/BusinessPage', BusinessPage);